import { render } from "./RightFixd.vue?vue&type=template&id=640f1ce6&scoped=true"
const script = {}

import "./RightFixd.vue?vue&type=style&index=0&id=640f1ce6&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640f1ce6"]])

export default __exports__